import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { changeNavBarBool } from '../../Navbar/actions';
import { getUserUrns } from '../../ProfileManager/actions';
import { clearIsNextEpisodePlayer } from '../PlayerSection/actions';
import { toastAdd } from '../../App/actions';
import { TOAST_TYPES } from '../../App/constants';

import * as actions from './actions';
import { TOAST_TEXT } from './constants';
import useClientConfigs from '../../../customHooks/useClientConfigs';

/**
 * DidMount like hook effect
 *
 * @export
 */
export function useDidMount(accessToken, section, authenticated) {
  const dispatch = useDispatch();
  React.useEffect(() => {
    // automatic scroll up
    window.scrollTo(0, 0);
    dispatch(changeNavBarBool(true));
    dispatch(actions.loadWidgets(accessToken, section.id, { active: true }));
    dispatch(clearIsNextEpisodePlayer());
    if (authenticated) {
      dispatch(getUserUrns(accessToken));
    }
    return () => {
      dispatch(actions.resetWidgets());
    };
  }, []);
}

export const usePrivacyModal = (pathCountry) => {
  const [showModal, setShowModal] = React.useState(false);
  const { enableUsPrivacy } = useClientConfigs();

  React.useEffect(() => {
    const usPrivacy = localStorage.getItem('usPrivacy');

    if (enableUsPrivacy && !usPrivacy) {
      if (pathCountry === '/us') {
        // US
        setShowModal(true);
      } else {
        // LATAM
        localStorage.setItem('usPrivacy', '1---');
      }
    }
  }, [enableUsPrivacy, pathCountry]);

  return { showModal, setShowModal };
};

/**
 * useToastAdd like hook effect
 *
 * @export
 */
export function useToastAdd() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  return useCallback(
    (toast) => {
      const title = TOAST_TEXT.TITLE;
      const message =
        TOAST_TEXT[toast.code] || TOAST_TEXT[toast] || TOAST_TEXT.DEFAULT;
      dispatch(
        toastAdd({
          toastType: TOAST_TYPES.ERROR,
          title: t(title),
          message: t(message),
          error: toast.message ? null : toast,
        }),
      );
    },
    [dispatch, t],
  );
}
